// Heuristic "does this definition fit the category?" check. Runs on the
// definition text, so it works whatever source the definition came from.
// Mirrors NameItApp/components/DictionaryLookup.tsx getCategoryMatch.
export function getCategoryMatch(definition, partOfSpeech, word, category) {
  if (!definition || !category) return null;

  const def = definition.toLowerCase();
  const pos = partOfSpeech?.toLowerCase() || "";
  const cat = category.toLowerCase();

  // Category matching rules
  const categoryRules = {
    animal: [
      // Direct animal indicators
      /\b(animal|mammal|bird|fish|reptile|amphibian|insect|creature|beast)\b/,
      /\b(species|breed|domesticated|wild|pet)\b/,
      // Specific animal types
      /\b(cat|dog|horse|cow|lion|tiger|elephant|bear|wolf|deer|rabbit|snake|frog)\b/,
      // Animal characteristics
      /\b(carnivorous|herbivorous|omnivorous|predator|prey)\b/,
      /\b(feathers|fur|scales|wings|tail|paws|hooves|bird)\b/,
    ],

    place: [
      // Geographic locations
      /\b(city|town|village|country|nation|state|province|county|region)\b/,
      /\b(capital|metropolitan|urban|rural|suburban)\b/,
      /\b(located|situated|found)\s+in\b/,
      // Specific places
      /\b(park|street|avenue|road|bridge|building|museum|school|hospital)\b/,
      /\b(continent|island|mountain|river|lake|ocean|sea|desert|forest)\b/,
    ],

    name: [
      // Person indicators (but be careful with common words)
      /\b(person|individual|man|woman|boy|girl|child)\b/,
      /\b(first name|given name|surname|nickname)\b/,
      // Usually proper nouns for names
      pos.includes("noun") && /^[A-Z]/.test(word),
    ],

    thing: [
      // Objects and items
      /\b(object|item|tool|device|instrument|equipment|gadget)\b/,
      /\b(made of|consists of|used for|designed to)\b/,
      // Common things
      /\b(book|pen|table|chair|computer|phone|car|house|food|drink)\b/,
      /\b(material|substance|product|invention)\b/,
    ],

    food: [
      /\b(food|dish|meal|cuisine|recipe|ingredient)\b/,
      /\b(eat|eaten|edible|nutritious|delicious|taste)\b/,
      /\b(fruit|vegetable|meat|grain|dairy|beverage|drink)\b/,
      /\b(cooked|baked|fried|grilled|steamed)\b/,
    ],

    profession: [
      /\b(job|occupation|profession|career|work|employment)\b/,
      /\b(doctor|teacher|engineer|lawyer|nurse|chef|artist|writer)\b/,
      /\b(specialist|expert|professional|worker|employee)\b/,
    ],

    sport: [
      /\b(sport|game|athletic|competition|tournament|match)\b/,
      /\b(play|played|player|team|ball|field|court)\b/,
      /\b(football|basketball|tennis|golf|swimming|running)\b/,
    ],
  };

  // Get rules for current category
  const rules = categoryRules[cat] || [];

  // Check if any rule matches
  for (const rule of rules) {
    if (rule instanceof RegExp && rule.test(def)) {
      return {
        matches: true,
        confidence: "high",
      };
    }
  }

  // Check for partial matches with lower confidence
  const partialMatches = {
    animal: /\b(living|alive|breathe|habitat|zoo|farm)\b/,
    place: /\b(where|location|area|site|spot)\b/,
    thing: /\b(something|anything|physical|solid|liquid)\b/,
  };

  if (partialMatches[cat] && partialMatches[cat].test(def)) {
    return {
      matches: true,
      confidence: "medium",
    };
  }

  return null;
}
